import { get, put, post, del, upload } from '@api/request';

export const fetchDiscoveries = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/discovery`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDiscovery = async (
  { litigationService },
  authenticationToken,
  { discoveryID },
) => {
  const url = `${litigationService}/litigation/discovery/${discoveryID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDiscoveryFiles = async (
  { litigationService },
  authenticationToken,
  { discoveryID },
) => {
  const url = `${litigationService}/litigation/discovery/${discoveryID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileDiscoveryStatus = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Discovery Status`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileFilingParty = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Filing Party`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertDiscovery = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/discovery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertDiscoveryFile = async (
  { litigationService },
  authenticationToken,
  { discoveryID, payload },
) => {
  const url = `${litigationService}/litigation/discovery/${discoveryID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const updateDiscovery = async (
  { litigationService },
  authenticationToken,
  { discoveryID, payload },
) => {
  const url = `${litigationService}/litigation/discovery/${discoveryID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updateDiscoveryTags = async (
  { litigationService },
  authenticationToken,
  { discoveryID, payload },
) => {
  const url = `${litigationService}/litigation/discovery/${discoveryID}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updateDiscoveryFile = async (
  { litigationService },
  authenticationToken,
  { discoveryID, payload },
) => {
  const url = `${litigationService}/litigation/offer/${discoveryID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteDiscovery = async (
  { litigationService },
  authenticationToken,
  { discoveryID },
) => {
  const url = `${litigationService}/litigation/discovery/${discoveryID}`;
  const { body } = await del(authenticationToken, url, discoveryID);
  return body;
};

export const deleteDiscoveryFile = async (
  { litigationService },
  authenticationToken,
  { payload, discoveryID, s3ID },
) => {
  const url = `${litigationService}/litigation/discovery/${discoveryID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadDiscoveryFile = async (
  { litigationService },
  authenticationToken,
  { discoveryID, s3ID },
) => {
  const url = `${litigationService}/litigation/discovery/${discoveryID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const fetchCodefileDiscoveryType = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codefiles?type=Litigation&name=Discovery Type`;
  const { body } = await get(authenticationToken, url);
  return body;
};
